/**
 * Skeleton fallback for the AccountSection Suspense boundary.
 *
 * Renders icon + text skeleton spans as direct children — NO <li> wrapper.
 * HeaderItemSkeleton (now exported from @pixum/web-header as of PXMCY-34743)
 * cannot be used here because it renders its own <li>, which would nest inside
 * HeaderItemTag's <li> and produce invalid HTML that breaks streaming hydration.
 * This fragment approach sets the skeleton visuals directly inside the outer <li>.
 */
export function AccountSectionStreamingSkeleton() {
  return (
    <>
      <span
        className="skeleton web-header__item-skeleton-icon"
        style={{ width: 24, height: 24, borderRadius: '50%', display: 'inline-block' }}
      />
      <span
        className="skeleton web-header__item-skeleton-text"
        style={{ width: 100, height: 20, marginLeft: 'var(--spacing-0_5)', display: 'inline-block' }}
      />
    </>
  );
}
